var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97502 0.346329C10.1606 0.437441 10.3109 0.587355 10.4025 0.772736C10.494 0.958117 10.5217 1.16857 10.4813 1.37133L9.45627 6.50008H14.5625C14.7422 6.50006 14.9182 6.5517 15.0693 6.64884C15.2205 6.74598 15.3406 6.88453 15.4153 7.04798C15.49 7.21144 15.5161 7.39292 15.4906 7.5708C15.465 7.74869 15.3889 7.91548 15.2713 8.05133L7.14627 17.4263C7.01072 17.5825 6.82733 17.6895 6.62466 17.7306C6.42199 17.7717 6.21141 17.7447 6.0257 17.6537C5.84 17.5627 5.68959 17.4129 5.59791 17.2275C5.50622 17.0421 5.47839 16.8316 5.51877 16.6288L6.54377 11.5001H1.43752C1.25781 11.5001 1.08188 11.4485 0.930688 11.3513C0.779495 11.2542 0.659407 11.1156 0.584726 10.9522C0.510044 10.7887 0.483916 10.6072 0.509454 10.4294C0.534991 10.2515 0.611117 10.0847 0.728767 9.94883L8.85377 0.573829C8.98934 0.417468 9.17284 0.310362 9.37566 0.269211C9.57848 0.228059 9.78922 0.255174 9.97502 0.346329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.8d976dfd53457d748b15771480a19e45.svg";
export { ForwardRef as ReactComponent };